import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";

interface BreadcrumbNavigationProps {
  showPersonaImportForm?: boolean;
  showOfferImportForm?: boolean;
  showPolicyForm?: boolean;
  isEditing: boolean;
  onBackToContext: () => void;
}

export function BreadcrumbNavigation({
  showPersonaImportForm,
  showOfferImportForm,
  showPolicyForm,
  isEditing,
  onBackToContext,
}: BreadcrumbNavigationProps) {
  return (
    <div className="flex items-center mb-6 text-sm">
      <Button
        variant="link"
        className="p-0 h-auto font-medium"
        onClick={onBackToContext}
      >
        Context
      </Button>
      <ChevronRight className="mx-2 h-4 w-4 text-muted-foreground" />
      <Button
        variant="link"
        className="p-0 h-auto font-medium"
        onClick={onBackToContext}
      >
        {showPersonaImportForm
          ? "Personas"
          : showOfferImportForm
            ? "Offers"
            : showPolicyForm
              ? "Policies"
              : "Context"}
      </Button>
      <ChevronRight className="mx-2 h-4 w-4 text-muted-foreground" />
      <span className="font-medium">
        {showPersonaImportForm || showOfferImportForm
          ? "Import"
          : isEditing
            ? "Edit"
            : "Add"}
      </span>
    </div>
  );
}

